import uuid from 'uuid/v4';
/**
 * This util takes adf input in string format and optional preset title.
 * It will parse adf input string to adf json.
 * If preset title is provided then it will create status node and
 *  it will prepend it to user input with once space between them.
 * @param userADFInput - User input in adf format
 * @param schema - adf schema to be used to generate adf document.
 * @param presetTitle - title of experience selected (e.g. summarise)
 * @returns
 */
export function prefixDocumentWithStatusNode(userADFInput, schema, presetTitle) {
  /**
   * We don't need to encode using JSONTransformer because,
   *  before saving in adf string we have already encoded document to json.
   * Checkout platform/packages/editor/editor-ai-injected-editors/src/editors/prompt.tsx
   * Just need to parse that json here.
   */
  const jsonDocument = JSON.parse(userADFInput);
  if (!presetTitle) {
    return jsonDocument;
  }
  const status = schema.nodes['status'];
  const statusNode = status.createChecked({
    color: 'neutral',
    localId: uuid(),
    text: presetTitle
  }, undefined);
  const statusJson = statusNode.toJSON();
  const textNode = schema.text(' ');
  const textJson = textNode.toJSON();
  const firstNode = jsonDocument.content[0];
  if (firstNode.type === 'paragraph') {
    const paragraphNode = firstNode;
    const paragraphContent = paragraphNode.content;
    if (paragraphContent) {
      paragraphNode.content = [statusJson, textJson].concat(paragraphNode.content);
    }
  }
  return jsonDocument;
}